import { Component, input, model } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'lib-search-input',
  imports: [TranslatePipe, FormsModule],
  templateUrl: './search-input.html',
  styleUrl: './search-input.scss',
})
export class SearchInput {
  public placeholder = input.required<string>();
  public searchTerm = model('');
}
